<template>
    <h1>AfWorkflow</h1>
</template>

<script>
  export default {
    data() {
      return {}
    },
  }
</script>

<style scoped>

</style>
